import { render, staticRenderFns } from "./AlertsSection.vue?vue&type=template&id=735d49e5&scoped=true&"
import script from "./AlertsSection.vue?vue&type=script&lang=js&"
export * from "./AlertsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735d49e5",
  null
  
)

export default component.exports